import axios from 'axios';
import { Helpers } from '../helpers/Helpers';

/**
 * Ayarlar > Entegrasyon Ayarları > HGS Kurumsal (04.11.2026, Burak): HGS hesabı ↔ firma, Chrome/Edge eklenti bağlantısı,
 * aktarımlar, aktarım hataları, bakiye hareketleri. HGS kullanıcı adı / şifresi Keylogx'e girilmez ve saklanmaz.
 * Yetki: "Ayarlar > Entegrasyon Ayarları" rota yetkisi; sunucu ayrıca firma üyeliğini ve HGS menü yetkisini kontrol eder.
 */
export const HGS_KURUMSAL_SAYFASI = 'Ayarlar > Entegrasyon Ayarları';

export interface HgsHesabi {
    id: string
    hesapNo: string
    hesapAdi: string | null
    aktif: boolean
    otomatikSenkron: boolean
    cekimSaati: string
    sonOturumDurumu: string | null
    sonOturumZamani: string | null
    sonAktarim: string | null
    sonBasariliAktarim: string | null
    sonAktarimSonucu: string | null
    sonHata: string | null
}

export interface HgsAktarimOzeti {
    id: string
    tarih: string
    hesapNo: string | null
    kullanici: string | null
    /** Aktarımda okunan plakalar (virgülle); eski "zaten kayıtlı" aktarımlarda boş olabilir. */
    plakalar: string | null
    sorguBaslangic: string | null
    sorguBitis: string | null
    okunan: number
    yeni: number
    guncellenen: number
    tekrar: number
    hatali: number
    eslesmeyenPlaka: number
    cokluSefer: number
    bakiyeOkunan: number
    bakiyeYeni: number
    durum: number
    durumAdi: string
    hata: string | null
}

export interface HgsKurumsalDurum {
    hesaplar: HgsHesabi[]
    aktifBaglanti: number
    baglantiBitis: string | null
    baglantiSonKullanim: string | null
    sonAktarimlar: HgsAktarimOzeti[]
    bekleyenHata: number
    anahtarSaati: number
}

export interface HgsAktarimHatasi {
    id: string
    olusturma: string
    hesapNo: string | null
    kaynakTuru: string
    plaka: string | null
    gecisTarihi: string | null
    gecisSaati: string | null
    girisYeri: string | null
    cikisYeri: string | null
    ucret: number | null
    hariciIslemNo: string | null
    hata: string
    durum: number
    durumAdi: string
}

export interface HgsBakiyeHareketi {
    id: string
    hesapNo: string | null
    plaka: string | null
    etiketNo: string | null
    islemTarihi: string
    islemSaati: string | null
    aciklama: string | null
    islemTuru: number
    islemTuruAdi: string
    girisTutari: number | null
    cikisTutari: number | null
    kalanBakiye: number | null
    gecisUcreti: boolean
    hariciIslemNo: string | null
    aktarimTarihi: string
}

export interface HgsHesabiKaydet {
    id?: string
    hesapNo: string
    hesapAdi?: string
    aktif: boolean
    otomatikSenkron: boolean
    cekimSaati: string
}

const cagir = async (yol: string, inputObj: any) => {
    try {
        // Istek govdesi loglanmaz; EklentiBagla yaniti (anahtar) da loglanmaz.
        console.log('SERVICE CALL - HgsKurumsal/' + yol);

        const resp = await axios.post(Helpers.getEndpoint() + '/HgsKurumsal/' + yol, inputObj);

        return Helpers.dataParser(resp);
    } catch (error) {
        throw Helpers.parseErrorMessage(error);
    }
}

export class HgsKurumsalService {
    static durum() { return cagir('Durum', {}); }
    static hesapKaydet(inputObj: HgsHesabiKaydet) { return cagir('HesapKaydet', inputObj); }
    static hesapSil(ids: string[]) { return cagir('HesapSil', { ids }); }
    static eklentiBagla() { return cagir('EklentiBagla', {}); }
    static baglantiKes() { return cagir('BaglantiKes', {}); }
    static aktarimlar() { return cagir('Aktarimlar', {}); }
    static hatalar(durum?: number) { return cagir('Hatalar', { durum }); }
    static hataYokSay(ids: string[]) { return cagir('HataYokSay', { ids }); }
    static hataYenidenIsle(ids: string[]) { return cagir('HataYenidenIsle', { ids }); }
    static bakiyeHareketleri(inputObj: { hgsHesabiId?: string, baslangic?: string, bitis?: string }) { return cagir('BakiyeHareketleri', inputObj); }
}
